import { graphql } from 'gatsby';
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews';
import React from 'react';

import BlogPost from '../components/blog/post/BlogPost';
import ScheduleDemoSection from '../components/common/sections/ScheduleDemoSection';
import Layout from '../components/layout/Layout';

const BlogPostTemplate = (props) => {
  const { data } = props;

  const blog = data.prismicBlog.data;

  return (
    <Layout
      title={blog.seo_title || blog.title}
      description={blog.seo_description || blog.summary}
      ogImage={blog.seo_image?.url || blog.feature_image.url}
      header="light"
      ogKeywords={blog.seo_keywords}
    >
      <BlogPost blog={blog} />
      <ScheduleDemoSection />
    </Layout>
  );
};

export const query = graphql`
  query blogPostQuery($id: String) {
    prismicBlog(id: { eq: $id }) {
      _previewable
      id
      uid
      data {
        summary
        content {
          html
          richText
          text
        }
        feature_image {
          url
        }
        seo_title
        seo_description
        seo_image {
          url
        }
        seo_keywords
        publish_date(formatString: "MMM D, YYYY")
        author
        title
        content_type
        body {
          ... on PrismicBlogDataBodyReferences {
            slice_type
            id
            primary {
              reference_list {
                html
              }
            }
          }
        }
      }
    }
  }
`;

export default withPrismicPreview(BlogPostTemplate);
